//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { version } from '../../package.json';

export default {
  name: 'ViuModal',
  props: {
    title: String,
    fullScreen: {
      type: Boolean,
      default: false
    },
    aside: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    version
  }),
  created() {
    document.addEventListener('keyup', this.checkKeyup);
  },
  destroyed() {
    document.removeEventListener('keyup', this.checkKeyup);
  },
  methods: {
    close(from) {
      this.$emit('close', from);
    },
    checkKeyup(event) {
      if (event.keyCode === 27) {
        this.close('esc');
      }
    }
  }
};
